module.exports = __webpack_public_path__ + "img/306.png";